define([
    "./commonsOptimizationModule",
    "./optimizationServiceInvoker",
    "./optimizationServiceUrl"
], function(){

});